// extracted by mini-css-extract-plugin
export default {"airplaneSizingContainer":"laa-z","narrowOptionButtons":"maa-z","noOptions":"naa-z"};